import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-locize-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import 'locize'

const locizeOptions = {
    projectId: process.env.REACT_APP_LOCIZE_PROJECTID as string,
    apiKey: process.env.REACT_APP_LOCIZE_APIKEY as string,
    version: process.env.REACT_APP_LOCIZE_BRANCH,
    referenceLng: 'da-DK',
}

i18n
    // i18next-http-backend
    // loads translations from your server
    // https://github.com/i18next/i18next-http-backend
    .use(Backend)
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        backend: locizeOptions,
        debug: false,
        fallbackLng: ['da-DK', 'en-GB'],
        defaultNS: 'bookingflow',
        ns: ['common', 'bookingflow'],
        react: {
            bindI18n: 'languageChanged editorSaved',
            useSuspense: false,
        },
    })

export default i18n
